import React from 'react';
import { useSelector } from 'react-redux';

import { BannerStatus, BannerLayout } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import { useEnablePickingExceptions } from '../../../feature-flags/hooks/use-enable-picking-exceptions';
import { useFulfillmentPlanIdContext } from '../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import Global from '../../../store/global-selectors';

export const PickingExceptionBanner = () => {
  const isPickingExceptionsEnabled = useEnablePickingExceptions();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();

  const pickBatchExceptionInfo = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'pickBatchExceptionInfo',
    }),
  );

  if (isPickingExceptionsEnabled && pickBatchExceptionInfo?.exceptionType) {
    return (
      <BannerMessageV2
        content={<Text textType={TextType.Paragraph} value={messages.pickingExceptionBannerDescription} />}
        header={<Text textType={TextType.Label} value={messages.pickingExceptionBannerTitle} />}
        layout={BannerLayout.Full}
        status={BannerStatus.Warning}
      />
    );
  }

  return null;
};
